import React, { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
/** Provided children are portaled to document.body or custom container. */
export const Portal = props => {
    const { children, containerRef, disablePortal } = props;
    const [mountNode, setMountNode] = useState();
    useEffect(() => {
        if (!disablePortal) {
            setMountNode(containerRef?.current ?? document.body);
        }
    }, [disablePortal]);
    if (disablePortal)
        return React.createElement(React.Fragment, null, children);
    return mountNode ? createPortal(children, mountNode) : React.createElement(React.Fragment, null, mountNode);
};
export default Portal;
